import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            Hello from Geek!
          </p>
          <a
            className="App-link"
            href="https://reactjs.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            Learn React! Created by Geek :) !
          </a>
    
           <a
            className="App-link"
            href="http://www.google.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Go to Google!
          </a>
        </header>
      </div>
    );
  }
}

export default App;
